import { render, staticRenderFns } from "./AddEditThirdcodeModal.vue?vue&type=template&id=1aef500a&scoped=true"
import script from "./AddEditThirdcodeModal.vue?vue&type=script&lang=ts"
export * from "./AddEditThirdcodeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef500a",
  null
  
)

export default component.exports